import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface TransactionFeesSettings {
  passTransactionFeesToCustomers: boolean;
  cardTransactionFees: string | undefined;
  cardFixedFee: string | undefined;
  achTransactionFees: string | undefined;
  updateInvoices: boolean;
  excludedParentIds: Array<{
    parentId: string;
    parentName: string;
    studentsNames: Array<string>;
  }>;
}

export interface TransactionFeesSettingsWithProvider {
  paymentProvider: string;
  passTransactionFeesToCustomers: boolean;
  cardTransactionFees?: string;
  cardFixedFee?: string;
  achTransactionFees?: string;
  updateInvoices?: boolean;
}

// Get all transaction fees settings for all payment providers
export const getAllTransactionFeesSettingsAPI = async (): Promise<
  Array<TransactionFeesSettingsWithProvider>
> => {
  const response = await baseAPI.get<
    Array<TransactionFeesSettingsWithProvider>
  >('/transaction-fees/all');
  return response.data;
};

// Get current transaction fees settings
export const getTransactionFeesSettingsAPI = async () => {
  const response = await baseAPI.get<TransactionFeesSettings>(
    '/transaction-fees/settings',
  );
  return response.data;
};

// React Query hook for fetching settings
export const useTransactionFeesSettings = () => {
  return useQuery({
    queryKey: [KEYS.TRANSACTION_FEES_SETTINGS],
    queryFn: getTransactionFeesSettingsAPI,
  });
};

// React Query hook for fetching all settings
export const useAllTransactionFeesSettings = () => {
  return useQuery({
    queryKey: [KEYS.TRANSACTION_FEES_ALL],
    queryFn: getAllTransactionFeesSettingsAPI,
  });
};
